export default {"src":"/_next/static/media/download.54230c82.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};